import type { FieldProps } from '@eliadmin/core/src/components/configurator/configurator-field';
import { useConfiguratorField } from '@eliadmin/core/src/components/configurator/configurator-field';
import { ConfiguratorFieldLabel } from '@eliadmin/core/src/components/configurator/configurator-field-label';
import { Textarea } from '@eliadmin/core/src/components/ui/textarea';
import { useDebounce } from '@eliadmin/core/src/hooks/use-debounce';
import { useErrSync } from '@eliadmin/core/src/stores/configurator-store';
import React, { useEffect } from 'react';

export function ConfigurationTextarea({ fieldConfig }: FieldProps<'textarea'>) {
  const { value, onChange } = useConfiguratorField(fieldConfig);
  const [internalValue, setInternalValue] = React.useState(value);
  const debouncedValue = useDebounce(internalValue, 300);

  useEffect(() => {
    if (value !== debouncedValue) onChange(debouncedValue);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedValue]);

  // useEffect(() => {
  //   setInternalValue(value);
  // }, [value]);

  const isInvalid = !value && fieldConfig.must === '1';
  useErrSync(fieldConfig.column, isInvalid);

  return (
    <div className="flex w-full flex-col gap-1">
      <ConfiguratorFieldLabel fieldConfig={fieldConfig} isInvalid={isInvalid} />
      <Textarea
        id={fieldConfig.column}
        value={internalValue}
        style={{ resize: 'vertical' }}
        className="border border-input bg-background shadow-none"
        rows={10}
        onChange={e => {
          setInternalValue(e.target.value);
        }}
        onBlur={() => {
          onChange(internalValue);
        }}
      />
    </div>
  );
}
